import { render, staticRenderFns } from "./CostGuidePage.vue?vue&type=template&id=32e078f6&scoped=true"
import script from "./CostGuidePage.vue?vue&type=script&lang=js"
export * from "./CostGuidePage.vue?vue&type=script&lang=js"
import style0 from "./CostGuidePage.vue?vue&type=style&index=0&id=32e078f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e078f6",
  null
  
)

export default component.exports